import { ReactElement } from 'react';
import { addMonths, differenceInDays, differenceInMonths, format, parseISO } from 'date-fns';
import { Box, BoxProps } from '@ff-it/ui';
import { formatInterval } from 'utilities';

type PeriodWidgetProps = {
  // when do we ever supprot incomplete periods?
  date_from: string;
  date_to: string;
  distance?: boolean;
  // renders date_from/date_to on separate lines, without collapsing the interval
  vertical?: boolean;
  // month?
} & BoxProps;

function dist(from: Date, to: Date): string {
  const parts = [];
  const months = Math.abs(differenceInMonths(to, from));
  if (months > 0) {
    parts.push(`${months}m`);
  }

  const afterMonths = addMonths(from, months);
  const days = Math.abs(differenceInDays(to, afterMonths)) + 1;
  if (days > 0) {
    parts.push(`${days}d`);
  }

  return parts.join(' ');
}

export function PeriodWidget({ date_from, date_to, distance, vertical, ...rest }: PeriodWidgetProps): ReactElement {
  const startDate = parseISO(date_from);
  const endDate = parseISO(date_to);

  return (
    <Box
      as="span"
      data-date_from={date_from}
      data-date_to={date_to}
      whiteSpace={vertical ? undefined : 'nowrap'}
      display={vertical ? 'flex' : undefined}
      flexDirection={vertical ? 'column' : undefined}
      {...rest}
    >
      {vertical ? (
        <>
          <Box as="span">{format(startDate, 'dd.MM.yyyy')}</Box>
          <Box as="span">{format(endDate, 'dd.MM.yyyy')}</Box>
        </>
      ) : (
        formatInterval(startDate, endDate)
      )}
      {distance && (
        <Box as="span" display={vertical ? undefined : 'inline'} ml={vertical ? undefined : '1'} color="gray500">
          {dist(startDate, endDate)}
        </Box>
      )}
    </Box>
  );
}
